/* Copyright (c) 2021-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloCache, Reference, StoreObject } from "@apollo/client";

export function removeFromApolloCache<T>(
  cache: ApolloCache<T>,
  item: Reference | StoreObject | string,
  listQueryName: string
) {
  cache.evict({
    id: typeof item === "string" ? item : cache.identify(item),
  });
  cache.evict({ id: "ROOT_QUERY", fieldName: listQueryName });

  cache.gc();
}
